import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import { FaqSectionDto } from '@/components/service-pages/Faq/types';
import { buildFaqPageJsonLd } from '@/lib/faq-page-schema';
interface Props {
  data: FaqSectionDto;
}
const FaqPageJsonLd: FC<Props> = t0 => {
  const $ = _c(4);
  const {
    data
  } = t0;
  if (!data.faqItems?.length) {
    return null;
  }
  let t1;
  if ($[0] !== data) {
    t1 = JSON.stringify(buildFaqPageJsonLd(data));
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: t1
    }} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default FaqPageJsonLd;